import { ValueObject } from './ValueObject';

export type ShippedHazardousGoods =
  | `explosive`
  | `gas`
  | `flammable`
  | `combustible`
  | `organic`
  | `poison`
  | `radioactive`
  | `corrosive`
  | `poisonousInhalation`
  | `harmfulToWater`
  | `other`;

export type TunnelCategory = `B` | `C` | `D` | `E`;

export type TruckType = `straight` | `tractor`;

export interface TruckOptionsProps {
  shipped_hazardous_goods?: ShippedHazardousGoods[];
  gross_weight?: number;
  height?: number;
  width?: number;
  length?: number;
  tunnel_category?: TunnelCategory;
  axle_count?: number;
  type?: TruckType;
  trailer_count?: number;
}

export class TruckOptions extends ValueObject<TruckOptionsProps> {
  get shipped_hazardous_goods(): ShippedHazardousGoods[] | undefined {
    return this.props.shipped_hazardous_goods;
  }
  set shipped_hazardous_goods(shippedHazardousGoods: ShippedHazardousGoods[] | undefined) {
    this.props.shipped_hazardous_goods = shippedHazardousGoods;
  }
  get gross_weight(): number | undefined {
    return this.props.gross_weight;
  }
  set gross_weight(grossWeight: number | undefined) {
    this.props.gross_weight = grossWeight;
  }
  get height(): number | undefined {
    return this.props.height;
  }
  set height(height: number | undefined) {
    this.props.height = height;
  }
  get width(): number | undefined {
    return this.props.width;
  }
  set width(width: number | undefined) {
    this.props.width = width;
  }
  get length(): number | undefined {
    return this.props.length;
  }
  set length(length: number | undefined) {
    this.props.length = length;
  }
  get tunnel_category(): TunnelCategory | undefined {
    return this.props.tunnel_category;
  }
  set tunnel_category(tunnelCategory: TunnelCategory | undefined) {
    this.props.tunnel_category = tunnelCategory;
  }
  get axle_count(): number | undefined {
    return this.props.axle_count;
  }
  set axle_count(axleCount: number | undefined) {
    this.props.axle_count = axleCount;
  }
  get type(): TruckType | undefined {
    return this.props.type;
  }
  set type(type: TruckType | undefined) {
    this.props.type = type;
  }
  get trailer_count(): number | undefined {
    return this.props.trailer_count;
  }
  set trailer_count(trailerCount: number | undefined) {
    this.props.trailer_count = trailerCount;
  }
  private constructor(props: TruckOptionsProps) {
    super(props);
  }
  static create(props: TruckOptionsProps): TruckOptions {
    return new TruckOptions(props);
  }
}
